(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  $(document).on('click', '.btn-checkout', function(event) {
    var note = $('#cartSpecialInstructions').val();

    $.post('/cart/update.js', {
      note: note
    });
  });

  } catch(e) { console.error(e); }
})();
})();
